import { styled } from '@mui/material';
import Grid from '@mui/material/Grid2';

export const GridContainer = styled(Grid)`
  padding-top: 1rem;
  max-width: 1620px;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 1100px) {
    gap: 0 !important;
  }
`;
